import { render, staticRenderFns } from "./ListAppNotifications.vue?vue&type=template&id=43ecdc91&scoped=true"
import script from "./ListAppNotifications.vue?vue&type=script&lang=js"
export * from "./ListAppNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ecdc91",
  null
  
)

export default component.exports